import { totalRecordDetailConstants } from '../constant/totalRecordDetail.constants';
import { totalRecordDetail } from '../services/totalRecordDetail.service';
import CONSTANT from '../constant/constant';
import functionCommon from "../common/function";

const _errorCode = CONSTANT.errorCode;

export const getTotalRecordDetailList = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        totalRecordDetail.list(data)
            .then(
                res => {
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                            dispatch(success(res));
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout()
                            break;
                        
                        case _errorCode.ClientNotPermission:
                            functionCommon.logout();
                            break;

                        default:
                            window.location = '/error/404';
                            break;
                    }
                   
                }
            );
    };

    function success(totalRecordDetailList) { 
        return { type:  totalRecordDetailConstants.GET_SUCCESS,  totalRecordDetailList }; 
    }
}

export const deleteTotalRecordDetailList = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        totalRecordDetail.delete(data)
            .then(
                res => {
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                            dispatch(success('004'));
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout()
                            break;
                        
                        case _errorCode.APIInvalids:
                            functionCommon.logout();
                            break;
    
                        case _errorCode.DBCanNotConnect:
                            window.location = '/error/404';
                            break;

                        default:
                            dispatch(failure(res['error_code']));
                            break;
                    }
                   
                }
            );
    };

    function success(code) { 
        return { type: totalRecordDetailConstants.DELETE_SUCCESS, code}; 
    }

    function failure(error) {
        return { type: totalRecordDetailConstants.DELETE_FAILURE, error }; 
    }
}
